import { generatePath } from 'react-router-dom';
import { RouteSegments } from '../routingClientAdmin.interface';
import { withOptionalDetailsId } from './withOptionalDetailsId';

export const generateMarkupRoute = (profileId?: number, symbolId?: number) => {
  const baseUrl = `/${RouteSegments.Root.Config}/${RouteSegments.Config.Markups}`;

  if (!profileId) {
    return baseUrl;
  }

  return generatePath(
    withOptionalDetailsId(`${baseUrl}/${RouteSegments.Markups.Profile}`),
    { profileId: String(profileId), id: symbolId },
  );
};
